<template>
  <div class="header">
    <div class="header-1">
      <div class="copyright">
        &copy;{{ $l.copyright }}
      </div>
      <manual />
    </div>

    <patent-pending />
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import Manual from '@/components/Login/Manual'
import PatentPending from '@/components/Login/PatentPending'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    Manual,
    PatentPending
  }
}
</script>

<style lang="scss" scoped>
.header {
  color: white;
  margin: 10px;
}

.header-1 {
  display: flex;
  justify-content: space-between;
}

.copyright {
  font-size: 0.6em;
}
</style>
